import { useCallback, useEffect, useRef } from "react";

export function useIntersectionObserver(
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit
) {
  const callbackRef = useRef(callback);
  const nodeRef = useRef<Element | null>(null);
  const intersectionObserver = useRef<IntersectionObserver | null>(null);
  const optionsRef = useRef(options);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    intersectionObserver.current = new IntersectionObserver((...args) => {
      callbackRef.current(...args);
    }, optionsRef.current);
    if (nodeRef.current) {
      intersectionObserver.current?.observe(nodeRef.current);
    }
    return () => {
      intersectionObserver.current?.disconnect();
    };
  }, []);

  const ref = useCallback((node: HTMLElement | null) => {
    if (node && node !== nodeRef.current) {
      if (nodeRef.current) {
        intersectionObserver.current?.unobserve(nodeRef.current);
      }
      nodeRef.current = node;
      intersectionObserver.current?.observe(node);
    }
  }, []);
  return { ref, intersectionObserver };
}
